module.exports = __webpack_public_path__ + "static/me-8317c666a7ef538f5bc3c1e7abd762b3.jpg";